import { render, staticRenderFns } from "./DataColumnsPredicateList.vue?vue&type=template&id=17f05d20"
import script from "./DataColumnsPredicateList.vue?vue&type=script&lang=js"
export * from "./DataColumnsPredicateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports